import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import logo from '../../../images/logo.svg';
import { armorTypesService } from '../../../services/armorTypesService';
import { membershipCatalogService } from '../../../services/membershipCatalogService';
import { vehicleService } from '../../../services/vehicleService';
import { codeService } from '../../../services/codeService';
import { giftCardService } from '../../../services/giftCardService';
import { membershipService } from '../../../services/membershipService';
import { productService } from '../../../services/productService';
import { usersService } from '../../../services/usersService';
import { useParams, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import {
  LandingRegisterStep1Form,
  DiscountForm,
} from '../../common/Forms/Form';
import { notify } from '../../../assets/helpers/toast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { salesRoles } from '../../../assets/helpers/roles';
import {
  clearObject,
  filterParams,
  convertRCVNameToId,
  capitalize,
  formatCurrency,
  filterById,
  filterRCVOptions,
  displayMembershipCode,
} from '../../../assets/helpers/funciones';
import {
  MembershipButton,
  GiftcardMessage,
  DiscountMessage,
  WizzardProgressBar,
} from './LandingComponents/LandingComponents';
import { PersonalInfoForm } from './LandingForms/PersonalInfoForm';
import { MultipleAffiliationForm } from './LandingForms/MultipleAffiliationForm';
import { CreateVehicleForm } from './LandingForms/CreateVehicleForm';
import { MultipleVehicleForm } from './LandingForms/MultipleVehicleForm';
import { PlanPurchaseForm } from './LandingForms/PlanPurchaseForm';
import { SuccesPurchase } from './LandingForms/SuccesPurchase';
import { rateService } from '../../../services/rateService';
import { saleChannelService } from '../../../services/saleChannelService';
import { Header } from '../../../components/common/Header/Header';
import * as schemas from '../../../assets/schemas/schemas';
import { Input } from '../../common/Forms/Input/Input';
import {
  codeTypeEnum,
  codeTypeOptions,
  fleetLoadRCVTypes,
  membershipCodes,
  LANDING,
  validateCodeEnum,
  KMServiceOptions,
  getPlanBaseKm,
  planAllowsUnlimitedTow,
  getUnlimitedTowLabel,
  isNewPlanRulesActive,
  isBeforePlanRelease,
  rcvEnum,
  vehicleWeightOptions,
  vehiclesEnum,
  membershipQuantityOptions,
  vehicleUsageOptions,
  vehicleUsageEnum,
} from '../../../assets/helpers/options';
import { vintageYear } from '../../../assets/helpers/const';
import authService from '../../../services/authService';
import './Landing.scss';
import { useVehicleClassesStore } from '../../../stores/useVehicleClassesStore';
import { useSalesChannelStore } from '../../../stores/useSalesChannelStore';
import { currencyRateService } from '../../../services/currencyRateService';
import { discountService } from '../../../services/discountService';
import moment from 'moment';
import { preloadMembershipData } from './LandingForms/helpers/preloadFuntions';
import { multipleMembershipsTableHeader } from '../../../assets/helpers/tables';
import { MultipleMembershipsTable } from './MultipleAfiliationComponents/MultipleMembershipsTable';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';

const CUSTOM_VEHICLE_ORDER_MAP = {
  'AUTOMÓVIL': 1,
  'CAMIONETA': 2,
  'RÚSTICO': 3,
  'MOTO': 4,
  'TRIMOTO': 5,
  'CAMIÓN': 6,
  'AUTOBUS': 7,
  'MINIBUS': 8,
  'GRÚA': 9,
  'AMBULANCIA': 10,
};

export const Landing = () => {
  const { saleChannel } = useParams();
  const location = useLocation();
  const { t } = useTranslation();
  const [giftCard, setGiftCard] = useState('');
  const [curentStep, setcurentStep] = useState(1);
  const [discountCode, setDiscountCode] = useState();
  const [membership, setMembership] = useState('');
  const [customer, setCustomer] = useState('');
  const [dollarRate, setDollarRate] = useState(1);
  const [dollarRateByDate, setDollarRateByDate] = useState(1);
  const [showAffiliation, setShowAlffiliation] = useState(false);
  const [rcvOptions, setRCVOptions] = useState([]);
  const [selectedMembership, setSelectedMembership] = useState('');
  const [sellerOptions, setSellerOptions] = useState([]);
  const [armorTypeOptions, setArmorTypeOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [membershipOptions, setMembershipOptions] = useState([]);
  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [noPlanAlert, setNoplanAlert] = useState(false);
  const [membershipList, setMembershipList] = useState([]);
  const [clientNumber, setClientNumber] = useState(0);
  const [vehicleFilerUsageOptions, setVehicleFilerUsageOptions] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch,
    setError,
    control,
  } = useForm({
    resolver: yupResolver(schemas.landingRegisterStep1Schema(t)),
    defaultValues: {
      createdAt: new Date(),
      sameDate: true,
    },
  });

  const yearWatch = useWatch({
    control,
    name: 'year',
  });

  const classWatch = useWatch({
    control,
    name: 'class',
  });

  // Nuevas condiciones de planes (km fijos por plan, ilimitado, sin recargos por año/blindaje)
  const createdAtWatch = useWatch({
    control,
    name: 'createdAt',
  });
  const newRules = isNewPlanRulesActive(createdAtWatch);

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    reset: reset2,
    watch: watch2,
    control: control2,
    getValues: getValues2,

  } = useForm({
    resolver: yupResolver(schemas.validateGiftcardSchema(t)),
  });

  const codeWatch2 = useWatch({
    control: control2,
    name: 'code',
  });

  const membershipsRequestRef = useRef({
    inFlight: false,
    key: '',
  });
  const membershipsLatestRequestRef = useRef(0);
  const promoAutoAppliedRef = useRef(false);

  const clearMembership = useCallback((list) => {
    setValue('year', '');
    setValue('class', '');
    setValue('armorType', '');
    setValue('rcv', '');
    setValue2('codeType', '');
    setValue2('code', '');
    setSelectedMembership('');
    setRCVOptions([]);
    setMembershipOptions([]);
    let canPost = true;

    for (let i = 0; i < list.length; i++) {
      if (!list[i]?.dataTable?.year) {
        canPost = false;
      }
    }
    if (canPost) setClientNumber(-1);
  }, [setValue, setValue2, setSelectedMembership]);

  const createMassive = useCallback(() => {
    // Validate Seller
    if (authService.getUser() && !watch('seller')) {
      setError(`seller`, {
        type: 'custom',
        message: 'Asesor requerido',
      });
      return null;
    }

    const dataToPost = [
      ...membershipList.map(
        ({ dataTable, customer, vehicle, membership, ...rest }) => {
          return {
            ...rest,
            saleChannel: watch('salesChannel'),
            seller: rest.seller || watch('seller'),
          };
        }
      ),
    ];

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .createMassive({ data: dataToPost })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            const memberships = response?.data?.memberships || [];
            const errors = response?.data?.errors || [];

            // The endpoint can answer 200 with errors and no memberships created
            if (errors.length > 0 || memberships.length !== membershipList.length) {
              if (errors.length > 0) {
                errors.forEach((error) => notify(`${error}`, 'error'));
              } else {
                notify('No se pudieron crear las membresías', 'error');
              }
              setIsloading(false);
              return;
            }

            const membershipWithId = membershipList.map((item, i) => ({
              ...item,
              membership: memberships[i]?._id,
            }));
            const finalPrice = membershipList.reduce(
              (sum, item) => sum + (item?.priceInfo?.finalPrice || 0),
              0
            );
            const siblingMemberships = memberships.slice(1).map((m) => m?._id);

            setMembershipList(membershipWithId);

            setMembership({
              siblingMemberships,
              _id: memberships[0]?._id,
              createdAt: watch('createdAt'),
              priceInfo: {
                finalPrice,
                finalPriceInBsS: finalPrice * dollarRateByDate,
              },
            });

            setcurentStep(2);
          } else {
            notify(`${response?.message}`, 'error');
          }
          setIsloading(false);
        })
        .catch((error) => {
          console.log('Landing: createMassive', error);
          setIsloading(false);
          console.error(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authService, watch, setError, membershipList, isLoading, dollarRateByDate, setcurentStep]);

  const loadMembershipTable = (dataToPost) => {
    if (clientNumber >= 0) {
      let list = [...membershipList];

      let data = {
        year: yearWatch,
        class: capitalize(
          filterById(vehicleClassesOptions, classWatch)?.name
        ),
        classId: capitalize(
          filterById(vehicleClassesOptions, classWatch)?._id
        ),
        armorType: capitalize(
          filterById(armorTypeOptions, watch('armorType'))?.name
        ),
        armorTypeId: filterById(armorTypeOptions, watch('armorType'))?._id,
        codeType: watch2('codeType'),
        code: getValues2('code'),
        rcv: watch('rcv'),
        plan: capitalize(displayMembershipCode(selectedMembership?.code)),
        // Vehicle Data from the second step if exists
        brand: list[clientNumber]?.dataTable?.brand,
        model: list[clientNumber]?.dataTable?.model,
        state: list[clientNumber]?.dataTable?.state,
        city: list[clientNumber]?.dataTable?.city,
        municipality: list[clientNumber]?.dataTable?.municipality,
        address: list[clientNumber]?.dataTable?.address,
        // Documents
        circulationCard: list[clientNumber]?.dataTable?.circulationCard,
        licenses: list[clientNumber]?.dataTable?.licenses,
        dni: list[clientNumber]?.dataTable?.dni,
      };

      dataToPost = {
        ...dataToPost,
        dataTable: data,
        customer: list[clientNumber]?.customer,
        vehicle: list[clientNumber]?.vehicle,
      };

      list[clientNumber] = dataToPost;

      setMembershipList(list);
      setClientNumber(clientNumber + 1);
      clearMembership(list);
      // Reser form
      return null;
    } else {
      notify('Ha superado el máximo de membresias a crear', 'error');
    }
  };

  const onSubmit = handleSubmit(async (data) => {
    // Validate weight if required
    if (validateTruck() && !watch('truckWeight')) {
      notify('Indique el peso del vehículo', 'error');
      return null;
    }

    // Validate required plan
    if (!selectedMembership) {
      notify('Seleccione un plan', 'error');
      setNoplanAlert(true);
      return null;
    }

    // Validate Km de Servicio de Grúa (obligatorio en planes Gold, solo condiciones anteriores)
    if (
      !newRules &&
      [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
        selectedMembership?.code
      ) &&
      !getValues('km')
    ) {
      setError('km', {
        type: 'custom',
        message: 'Seleccione el Km de servicio de grúa',
      });
      notify('Seleccione el Km de servicio de grúa', 'error');
      return null;
    }

    // Validate Seller
    if (authService.getUser() && !watch('seller')) {
      setError(`seller`, {
        type: 'custom',
        message: 'Asesor requerido',
      });
      return null;
    }

    // Validate vehicle usage
    if (
      [rcvEnum?.RCV_BASIC]?.includes(watch('rcv')) &&
      !watch('vehicleUsage')
    ) {
      setError(`vehicleUsage`, {
        type: 'custom',
        message: 'Seleccione el uso del vehículo',
      });
      return null;
    }

    // if (!authService.getUser()) {
    //   const dataLayer = {
    //     event: 'funnel_step_vehicle',
    //     vehicle_year: watch("year"),
    //     vehicle_class: filterById(vehicleClassesOptions, classWatch)?.name,
    //     vehicle_armored: watch('armorType') ? "Si" : "No",
    //     coupon_type: watch2('codeType'),
    //     coupon: codeWatch2,
    //     plan_name: filterById(membershipOptions, selectedMembership?._id)?.code,
    //     plan_category: '',
    //     km_crane_service: watch("km"),
    //     rcv: watch("rcv"),
    //     vehicle_use: data?.vehicleUsage,
    //     crane_unlimited: watch('useExtendedTow') ? "Si" : "No"
    //   }
    //   // If logged In
    //   window.dataLayer.push(dataLayer);
    // }

    // ? Desestructuramos para limpiar la creación del objeto "priceInfo"
    const {
      finalPriceBeforeDiscounts,
      originalPrice: initialValue, // Renombramos de originalPrice a initialValue
      yearSurcharge,
      armorTypeSurcharge,
      classSurcharge,
      rcvSurcharge,
      discountByCode,
      finalPrice,
      extendedTowSurcharge,
      discountToRcv,
    } = selectedMembership || {};

    const dataToPost = clearObject({
      membershipId: selectedMembership?._id,
      giftcard: giftCard?._id,
      discountCode: discountCode?._id,
      rcv: convertRCVNameToId(data?.rcv, rcvOptions),
      km: getValues('km'), // Usa 'data' en lugar de 'watch'
      truckWeight: data?.truckWeight,
      useExtendedTow: data?.useExtendedTow,
      saleChannel, // Se puede omitir ": saleChannel" si se llama igual
      vehicleUsage: data?.vehicleUsage,
      priceInfo: {
        finalPriceBeforeDiscounts,
        initialValue,
        yearSurcharge,
        armorTypeSurcharge,
        classSurcharge,
        rcvSurcharge,
        discountByGiftcard: giftCard?.value || 0, // Simplificado
        discountByCode,
        finalPrice,
        extendedTowSurcharge,
        discountToRcv,
      },
      seller: data?.seller,
      createdAt: moment(data.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      useMedCert: getValues('useMedCert') || false,
      hasRcvCard: getValues('hasRcvCard') || false,
    });

    if (!dataToPost?.rcv) {
      delete dataToPost?.rcv;
    }

    if (authService.getUser()) {
      loadMembershipTable(dataToPost);
    } else {
      if (!isLoading) {
        setIsloading(true);
        membershipService
          .createMembership(dataToPost)
          .then((response) => {
            if ([200, 201].includes(response?.status)) {
              setMembership(response?.data?.membership);
              if (authService.getUser()) {
                getCurrencyRateByDate();
              }
              setcurentStep(2);
              setIsloading(false);
            } else {
              notify(`${response?.message}`, 'error');
              setIsloading(false);
            }
          })
          .catch((error) => {
            console.log('Landing: createMembership', error);
            setIsloading(false);
          });
      }
    }
  });

  const handleSameDateChange = () => {
    getCurrencyRateByDate();

    if (watch('sameDate')) {
      setValue('paymentDate', null);
    } else {
      setValue('paymentDate', watch('createdAt'));
    }
  };

  const getRateWithoutLogin = () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          console.log('!!! Dollar Rate Response:', response);
          setDollarRateByDate(response?.data?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  }

  const getCurrencyRateByDate = () => {
    if (!authService.getUser()) {
      getRateWithoutLogin();
      return;
    }

    let date = '';

    if (watch('createdAt') && !membership.createdAt) {
      date = moment(watch('createdAt')).format('YYYY-MM-DD');
    }

    if (watch('paymentDate') && !watch('sameDate')) {
      date = moment(watch('paymentDate')).format('YYYY-MM-DD');
    }

    let params = {
      currency: 'USD',
      date: date ? date : '',
      limit: 1,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          console.log('Currency Rate by Date Response:', response);
          let rate = response?.data?.result[0]?.rate;
          setDollarRateByDate(rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        console.log('Landing: getCurrencyRateByDate', error);
      });
    return true;
  };

  const handleRCVChange = () => {
    setValue('vehicleUsage', '');
    getAvailableMemberships(selectedMembership, true); // Boolean for not setting the RCV
    getRCVs(selectedMembership, true); // Boolean for not setting the RCV
  };

  const handleVehicleUsage = () => {
    getAvailableMemberships(selectedMembership);
    getRCVs(selectedMembership, true);
  };

  const filterAndSetUssage = (usageOptions, vehicleOptions, _class) => {
    if (usageOptions.includes(_class.name)) {
      const options = vehicleUsageOptions?.filter((option) =>
        vehicleOptions.includes(option?._id)
      );
      setVehicleFilerUsageOptions(options);
      if (options.length === 1) {
        setValue('vehicleUsage', options[0]?._id);
      }
    }
  };

  const filterVehicleUse = () => {
    const selectedClassId = watch('class') || classWatch;
    const _class = filterById(vehicleClassesOptions, selectedClassId);

    if (!_class?.name) {
      setVehicleFilerUsageOptions([]);
      return;
    }

    filterAndSetUssage(
      [vehiclesEnum?.AUTOMOVIL],
      [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.RUSTICO],
      [
        vehicleUsageEnum.PUBLIC,
        vehicleUsageEnum.PARTICULAR,
        vehicleUsageEnum.LOAD,
      ],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.AUTOBUS, vehiclesEnum?.MINIBUS],
      [vehicleUsageEnum.PUBLIC],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.CAMIONETA],
      [
        vehicleUsageEnum.PUBLIC,
        vehicleUsageEnum.PARTICULAR,
        vehicleUsageEnum.LOAD,
      ],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.MOTO],
      [vehicleUsageEnum.LOAD, vehicleUsageEnum.PARTICULAR],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.TRIMOTO],
      [vehicleUsageEnum.LOAD],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.AMBULANCIA],
      [vehicleUsageEnum.LOAD],
      _class
    );
    filterAndSetUssage(
      [vehiclesEnum?.CAMION, vehiclesEnum?.GRUA],
      [vehicleUsageEnum.LOAD, vehicleUsageEnum.TOW],
      _class
    );
  };

  const changeVehicleData = () => {
    setValue('vehicleUsage', '');
    reset2();
    setGiftCard('');
    setDiscountCode('');
    setMembershipOptions([]);
    setSelectedMembership('');
    getAvailableMemberships(selectedMembership);
    filterVehicleUse();
    getRCVs(selectedMembership);
  };

  const getUsers = useCallback(async () => {
    let user = localStorage.getItem('user');

    if (user) {
      let params = {
        limit: 1000000,
        offset: 0,
        module: 'Ventas',
        status: 'Activo',
      };
      usersService
        .getUsers(params)
        .then((response) => {
          if (response.status === 200) {
            let data = [];
            for (let i = 0; i < response?.data?.users?.length; i++) {
              data?.push({
                _id: response?.data?.users[i]?._id,
                name:
                  response?.data?.users[i]?.firstName +
                  '  ' +
                  response?.data?.users[i]?.lastName,
              });
            }

            setSellerOptions(data);

            let [selectedUser] = data?.filter(
              (user) => user?._id === authService?.getUser()?._id
            );
            setValue('seller', selectedUser?._id);
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          console.log('Landing: getUsers', error);
        });
    }
  }, [setValue]);

  const validateDiscountCode = useCallback((code, showErrors = true) => {
    const normalizedCode = (code || '').toUpperCase();

    if (!normalizedCode) {
      return Promise.resolve(false);
    }

    const params = {
      code: normalizedCode,
      type: validateCodeEnum?.NEW,
    };

    setIsloading(true);

    return codeService
      .validateCode(filterParams(params))
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          setDiscountCode(response?.data);
          setValue2('codeType', codeTypeEnum.DISCOUNT);
          setValue2('code', normalizedCode);
          return true;
        }

        if ([404].includes(response.status) && showErrors) {
          notify(`Codigo de descuento no encontrado o expirado`, 'error');
          return false;
        }

        if (showErrors) {
          notify(`${response.message}`, 'error');
        }

        return false;
      })
      .catch((error) => {
        console.log('Landing: validateDiscountCode', error);
        if (showErrors) {
          notify('Error validando el código de descuento', 'error');
        }
        return false;
      })
      .finally(() => {
        setIsloading(false);
      });
  }, [setValue2]);

  const tryApplyActiveLandingDiscount = useCallback(() => {
    const params = {
      landing: authService.getUser() ? LANDING?.PRIVATE : LANDING?.PUBLIC,
    };

    return discountService
      .getActiveDiscount(filterParams(params))
      .then((response) => {
        if (response?.status !== 200) {
          return false;
        }

        const code = response?.data?.discountCode?.code;

        if (!code) {
          return false;
        }

        return validateDiscountCode(code, false);
      })
      .catch((error) => {
        console.log('Landing: tryApplyActiveLandingDiscount', error);
        return false;
      });
  }, [validateDiscountCode]);

  const onSubmit2 = handleSubmit2(async (data) => {
    let params = {
      code: data?.code,
      type:
        data?.codeType === codeTypeEnum.DISCOUNT ? validateCodeEnum?.NEW : '',
    };

    if (data?.codeType === codeTypeEnum.DISCOUNT) {
      setGiftCard('');
      await validateDiscountCode(data?.code);
    }

    if (data?.codeType === codeTypeEnum.GIFTCARD) {
      setDiscountCode('');
      setIsloading(true);

      giftCardService
        .validateCode(filterParams(params))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setGiftCard(response?.data);
            setValue2('code', data?.code);
          } else {
            if ([404].includes(response.status)) {
              notify(`Giftcard no encontrada o expirada`, 'error');
              return null;
            }

            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => {
          console.log('Landing: validateGiftCard', error);
          console.error(error);
        })
        .finally(() => {
          setIsloading(false);
        });
    }
  });

  const getSalesChannel = useCallback(() => {
    const user = authService.getUser();
    if (!user) return;

    const { getCache, setCache } = useSalesChannelStore.getState();
    const cachedData = getCache('salesChannels');

    if (cachedData && cachedData.salesChannels) {
      setSalesChannelOptions(cachedData.salesChannels);
      setValue('salesChannel', user?.saleChannel);
      return;
    }

    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if (response.status === 200) {
          const channels = response?.data?.saleChannels || [];
          setCache(channels, 'salesChannels', channels.length);
          setSalesChannelOptions(channels);
          setValue('salesChannel', user?.saleChannel);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [setValue]);

  const getSalesVehicleClasses = useCallback(() => {
    const { getCache, setCache } = useVehicleClassesStore.getState();
    const cachedData = getCache('vehicleClasses');

    if (cachedData && cachedData.classes) {
      setVehicleClassesOptions(cachedData.classes);
      return;
    }

    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          const classes = response?.data?.classes || [];
          const sortedClasses = [...classes].sort(
            (a, b) =>
              (CUSTOM_VEHICLE_ORDER_MAP[a.name] || 99) -
              (CUSTOM_VEHICLE_ORDER_MAP[b.name] || 99)
          );

          setCache(sortedClasses, 'vehicleClasses', sortedClasses.length);
          setVehicleClassesOptions(sortedClasses);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((e) => console.error(e));
  }, []);

  const getArmorTypes = useCallback(() => {
    armorTypesService
      .getArmorTypes()
      .then((response) => {
        if (response.status === 200) {
          const armorTypes = [...(response?.data || [])];
          armorTypes.push({
            _id: '',
            name: 'No',
          });
          setArmorTypeOptions(armorTypes);
          setValue('armorType', '');
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  }, [setValue]);

  const getDollarRate = useCallback(() => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  }, []);

  const selectMembership = (membership) => {
    if (newRules) {
      // Los km base del plan los asigna el backend: no se envía km al crear
      setValue('km', '');
    } else if (
      [membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
        membership?.code
      )
    ) {
      setValue('km', getPlanBaseKm(membership?.code, watch('createdAt')));
    } else {
      setValue('km', '');
    }
    if (!planAllowsUnlimitedTow(membership?.code, watch('createdAt'))) {
      setValue('useExtendedTow', false);
    }
    setSelectedMembership(membership);
    setNoplanAlert(false);
    if (!watch('rcv')) {
      setValue('rcv', rcvEnum?.NA);
    }
    getRCVs(membership);
  };

  const getRCVs = (membership, keepRCV) => {
    if (membership?._id) {
      let params = {
        membership: membership?._id,
        vehicleClass: classWatch,
        truckWeight: watch('truckWeight'),
        vehicleUsage: watch('vehicleUsage'),
      };
      productService
        .getRCVs(filterParams(params))
        .then((response) => {
          if (response.status !== 200) {
            notify(`${response.message}` || 'error', 'error');
            return;
          }

          const data = filterRCVOptions([
            { _id: fleetLoadRCVTypes?.N_A, name: fleetLoadRCVTypes?.N_A },
            ...response?.data?.map((item) => ({
              _id: item?.name,
              name: item?.name,
              mongoId: item?._id,
              coverage: item?.prices?.coverage,
            })),
          ]);

          setRCVOptions(data);

          if (keepRCV) return;

          const rcvMap = {
            [membershipCodes?.RCV_ELITE]: 'RCV INTERVIAL BÁSICO',
            [membershipCodes?.RCV_PREMIUM]: fleetLoadRCVTypes.RCV_PREMIUM,
            [membershipCodes?.RCV]: fleetLoadRCVTypes.RCV_STANDARD,
            [membershipCodes?.FREE]: data[0]?.name,
          };

          const rcvValue =
            rcvMap[membership?.code] ||
            data.find((r) => r?.name === fleetLoadRCVTypes.RCV_STANDARD)?.name;

          setValue('rcv', rcvValue);

          // Only call getAvailableMemberships for default case
          if (!rcvMap[membership?.code]) {
            getAvailableMemberships(membership);
          }
        })
        .catch((error) => {
          console.log('Landing: getRCVs', error);
        });
    }
  };

  const handleDiscountChange = () => {
    setGiftCard('');
    getAvailableMemberships(selectedMembership);
  };

  const handleGiftCardChange = () => {
    setDiscountCode('');
    getAvailableMemberships(selectedMembership);
  };

  const getAvailableMemberships = useCallback((selectedMembership, keepRCV) => {
    const currentClass = watch('class') || classWatch;

    if (
      (giftCard && watch2('codeType') === codeTypeEnum.DISCOUNT) ||
      (discountCode && watch2('codeType') === codeTypeEnum.GIFTCARD)
    ) {
      setValue2('code', '');
    }
    if (yearWatch?.length < 4) {
      setMembershipOptions([]);
      setSelectedMembership('');
      return null;
    }
    if (yearWatch && yearWatch > new Date().getFullYear() + 1) {
      notify('Ingrese un año valido', 'error');
      return null;
    }

    if (yearWatch && yearWatch < vintageYear) {
      notify(
        `El año del vehículo debe ser mayor a ${vintageYear - 1}`,
        'error'
      );
      return null;
    }

    const defaultRcv = rcvEnum.RCV_STANDARD;
    const resolvedRcv = watch('rcv') || (!keepRCV ? defaultRcv : '');

    if (!watch('rcv') && !keepRCV) {
      setValue('rcv', defaultRcv);
    }

    let params = {
      year: yearWatch,
      class: currentClass,
      truckWeight: watch('truckWeight'),
      armorType: watch('armorType'),
      discountCode: discountCode?._id,
      giftCard: giftCard?._id,
      rcv: resolvedRcv,
      vehicleUsage: watch('vehicleUsage'),
      landing: authService?.getUser() ? LANDING?.PRIVATE : LANDING?.PUBLIC,
      km: watch('km'),
      useExtendedTow: watch('useExtendedTow'),
      ...(watch('hasRcvCard') && { hasRcvCard: watch('hasRcvCard') }),
    };

    if (authService.getUser()) {
      params.rcvEmissionDate = moment(watch('createdAt')).format('YYYY-MM-DD');
      params.useMedCert = watch('useMedCert');
    }

    if (!currentClass) {
      setMembershipOptions([]);
      setSelectedMembership('');
      return null;
    }

    if (yearWatch && currentClass) {
      const filteredParams = filterParams(params);
      const requestKey = JSON.stringify(filteredParams);

      if (
        membershipsRequestRef.current.inFlight &&
        membershipsRequestRef.current.key === requestKey
      ) {
        return null;
      }

      membershipsRequestRef.current = {
        inFlight: true,
        key: requestKey,
      };
      const requestId = membershipsLatestRequestRef.current + 1;
      membershipsLatestRequestRef.current = requestId;

      setIsloading(true);
      membershipCatalogService
        .getAvailableMemberships(filteredParams)
        .then((response) => {
          if (requestId !== membershipsLatestRequestRef.current) {
            return;
          }

          if (response.status === 200) {
            setIsloading(false);
            let data = [...response?.data];

            let validGiftcard = response?.data?.some(
              (r) => r?.discountByGiftCard
            );

            if (validGiftcard) {
              data = data?.filter((d) => d?.discountByGiftCard);
            }

            setMembershipOptions(data);
            setSelectedMembership((prev) => {
              if (!prev?._id) return prev;
              const option = data.find((d) => d?._id === prev._id);
              return option ?? '';
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
          console.error(error);
        })
        .finally(() => {
          membershipsRequestRef.current.inFlight = false;
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    giftCard,
    watch2,
    discountCode,
    setValue2,
    yearWatch,
    classWatch,
    watch,
    setValue,
  ]);

  const transformToUppercase = () => {
    setValue2('code', getValues2('code').toUpperCase());
  };

  const cancel = () => {
    setGiftCard('');
    setDiscountCode('');
    reset();
    reset2();
    setMembershipList([]);
    setSelectedMembership('');
    setClientNumber(0);
    setMembershipOptions([]);
    setRCVOptions([]);
  };

  const clearStorageData = () => {
    sessionStorage.removeItem('personalData');
    sessionStorage.removeItem('payment');
    sessionStorage.removeItem('vehicle');
    sessionStorage.removeItem('customer');
  };

  const checkSaleChannel = () => {
    if (saleChannel) {
      setShowAlffiliation(true);
    }
  };

  const applyMembershipQuoteFromStorage = useCallback(() => {
    if (!authService.getUser()) return false;

    const rawQuote = sessionStorage.getItem('membershipQuote');
    if (!rawQuote) return false;

    try {
      const quote = JSON.parse(rawQuote);
      const list = quote?.membershipList;
      if (!Array.isArray(list) || !list.length || !list[0]?.membershipId) {
        return false;
      }

      sessionStorage.removeItem('membershipQuote');

      membershipsLatestRequestRef.current += 1;
      setShowAlffiliation(true);
      setValue('membershipQuantity', list.length);
      setMembershipList(list);
      setClientNumber(-1);
      setSelectedMembership('');
      setMembershipOptions([]);
      setRCVOptions([]);
      setDiscountCode();
      setGiftCard('');
      setValue2('codeType', '');
      setValue2('code', '');
      setValue('year', '');
      setValue('class', '');
      setValue('armorType', '');
      setValue('rcv', '');
      setValue('truckWeight', '');
      setValue('vehicleUsage', '');
      setValue('km', '');
      setValue('useExtendedTow', false);
      setValue('useMedCert', false);
      setValue('hasRcvCard', false);
      promoAutoAppliedRef.current = true;

      if (quote.rate) {
        setDollarRateByDate(quote.rate);
      }

      if (quote.quoteDate) {
        setValue('createdAt', moment(quote.quoteDate, 'YYYY-MM-DD').toDate());
        currencyRateService
          .getCurrencyRates({
            currency: 'USD',
            date: quote.quoteDate,
            limit: 1,
          })
          .then((response) => {
            if (response.status === 200 && response?.data?.result?.[0]?.rate) {
              setDollarRateByDate(response.data.result[0].rate);
            }
          })
          .catch((error) => {
            console.log('Landing: membershipQuote rate', error);
          });
      }

      return true;
    } catch (error) {
      console.log('Landing: membershipQuote preload', error);
      return false;
    }
  }, [setValue, setValue2]);

  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    // 1. Limpieza inicial
    clearStorageData();

    // 2. Disparar peticiones a la API en paralelo
    getSalesChannel();
    getUsers();
    getDollarRate();
    getArmorTypes();
    getSalesVehicleClasses();

    const hasQuote = Boolean(sessionStorage.getItem('membershipQuote'));
    if (!hasQuote) {
      getCurrencyRateByDate();
    }

    // 3. Lógica sincróna o dependiente de la sesión
    checkSaleChannel();

    if (authService.getUser()) {
      setShowAlffiliation(true);
      setValue('membershipQuantity', 1);
      applyMembershipQuoteFromStorage();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!initialized.current) return;
    applyMembershipQuoteFromStorage();
  }, [location.search, applyMembershipQuoteFromStorage]);

  // Efecto para reaccionar a cambios en el vehículo
  useEffect(() => {
    const isYearValid = yearWatch?.length === 4 && yearWatch >= vintageYear;
    const hasCodeInInput = Boolean(getValues2('code'));

    if (isYearValid && classWatch) {
      if (
        !promoAutoAppliedRef.current &&
        !discountCode &&
        !giftCard &&
        !hasCodeInInput
      ) {
        promoAutoAppliedRef.current = true;
        tryApplyActiveLandingDiscount().then((applied) => {
          if (!applied) {
            getAvailableMemberships();
          }
        });
        return;
      }

      getAvailableMemberships();
    }
  }, [
    yearWatch,
    classWatch,
    discountCode,
    giftCard,
    getValues2,
    getAvailableMemberships,
    tryApplyActiveLandingDiscount,
  ]);

  const validateTruck = () => {
    const [camion] = vehicleClassesOptions?.filter(
      (option) => option?._id === classWatch
    );
    if (
      [
        vehiclesEnum.CAMION,
        vehiclesEnum.AMBULANCIA,
        vehiclesEnum.GRUA,
      ].includes(camion?.name)
    ) {
      return true;
    } else return false;
  };

  const rcvCoverage = () => {
    let [selectedRCV] = rcvOptions?.filter((r) => r?._id === watch('rcv'));

    if (
      selectedRCV?.coverage &&
      [
        fleetLoadRCVTypes?.RCV_BASIC,
        fleetLoadRCVTypes?.RCV_AMPLIO,
        fleetLoadRCVTypes?.RCV_STANDARD,
        fleetLoadRCVTypes?.RCV_PREMIUM,
      ]?.includes(selectedRCV?.name)
    ) {
      return (
        <h6>
          {capitalize(selectedRCV?.name)} - Coberturas :<br />
          <ul>
            {selectedRCV?.coverage?.propertyDamageEur && (
              <li style={{ marginTop: '6px' }}>
                Daños a cosas €
                {formatCurrency(
                  selectedRCV?.coverage?.propertyDamageEur?.toFixed(2)
                )}
              </li>
            )}
            {selectedRCV?.coverage?.personalInjuryEur && (
              <li style={{ marginTop: '6px' }}>
                Daños a terceros €
                {formatCurrency(
                  selectedRCV?.coverage?.personalInjuryEur?.toFixed(2)
                )}
              </li>
            )}
          </ul>
          <h6>Coberturas Adicionales :</h6>
          <ul>
            {selectedRCV?.coverage?.limitExcess && (
              <li style={{ marginTop: '6px' }}>
                Exceso de limite $
                {formatCurrency(selectedRCV?.coverage?.limitExcess?.toFixed(2))}
              </li>
            )}
            {selectedRCV?.coverage?.accidentalDeath && (
              <li style={{ marginTop: '6px' }}>
                Muerte Accidental $
                {formatCurrency(
                  selectedRCV?.coverage?.accidentalDeath?.toFixed(2)
                )}
              </li>
            )}
            {selectedRCV?.coverage?.totalInvalidity && (
              <li style={{ marginTop: '6px' }}>
                Invalidez total y permanente $
                {formatCurrency(
                  selectedRCV?.coverage?.totalInvalidity?.toFixed(2)
                )}
              </li>
            )}
          </ul>
        </h6>
      );
    }
  };

  const determinValidDate = () => {
    // let createdAt = new Date(watch('createdAt'));
    let createdAt = new Date();
    let minDate = createdAt;
    minDate.setDate(minDate.getDate() - 4);

    if ([salesRoles?.SALES_ADMIN].includes(authService.getUserType())) {
      return false;
    }
    if (
      [
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS
      ].includes(authService.getUserType())
    ) {
      return minDate;
    } else return false;
  };

  const handleStep = useCallback((index) => {
    if (['true', true].includes(process.env.REACT_APP_DEVELOP)) {
      setcurentStep(index);
    }
  }, [setcurentStep]);

  const preloadMembership = () => {
    preloadMembershipData(setValue, vehicleClassesOptions);
    getAvailableMemberships();
    filterVehicleUse();
  };

  const handleMembershipList = () => {
    let data = [];
    for (let i = 0; i < parseFloat(watch('membershipQuantity')); i++) {
      data.push({});
    }
    setMembershipList(data);
  };

  const editMembership = (index) => {
    setClientNumber(index);
    setValue('year', membershipList[index].dataTable.year);
    setValue('class', membershipList[index].dataTable.classId);
    setValue('armorType', membershipList[index].dataTable.armorTypeId);
    setValue('rcv', membershipList[index].dataTable.rcv);
    setValue2('codeType', '');
    setValue2('code', '');

    const selectedMembershipRef = { _id: membershipList[index]?.membershipId };

    Promise.allSettled([
      getAvailableMemberships(selectedMembershipRef, true),
      getRCVs(selectedMembershipRef, true),
    ]);
  };

  const multipleMembershipsTable = {
    header: multipleMembershipsTableHeader,
    data: membershipList,
    dollarRateByDate: dollarRateByDate,
    membershipQuantity: parseFloat(watch('membershipQuantity')),
    actions: { editMembership: editMembership },
    clientNumber: clientNumber,
  };

  useEffect(() => {
    getAvailableMemberships();
  }, [giftCard, discountCode, getAvailableMemberships]);

  const elColor = useMemo(() => {
    const pathname = window.location.pathname;
    return pathname === '/new-membership' && authService?.getUserType()
      ? '#bce7f4'
      : '';
  }, []);

  const purchaseMembership = useMemo(() => ({ codigo: codeWatch2, ...membership }), [codeWatch2, membership]);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const vehicleMemo = useMemo(() => getValues(), [curentStep, getValues]);

  const createVehicleMembership = useMemo(() => ({
    class: capitalize(filterById(vehicleClassesOptions, classWatch)?.name),
    ...membership
  }), [vehicleClassesOptions, classWatch, membership]);

  return (
    <>
      <LoadSpinner show={isLoading} />
      <Header />

      <div style={{ backgroundColor: elColor, minHeight: '1000px' }}>
        <div className="container landing-container">
          <div className="row">
            <img src={logo} alt="logo" className="landing-logo" />
            <h1 style={{ marginBottom: '0px' }} className="title-component">
              Compra tu plan
            </h1>
            <div className="buttons-container wizzard-row">
              <WizzardProgressBar
                curentStep={curentStep}
                setcurentStep={handleStep}
              />
            </div>
            {!showAffiliation && (
              <>
                <h1 className="sub-title-component">¿Qué deseas hacer?</h1>
                <div
                  style={{ marginTop: '24px', marginBottom: '70px' }}
                  className="buttons-center-container "
                >
                  <ActionButton
                    label={'Renovar mi plan'}
                    action={() =>
                      window.open(
                        process.env.REACT_APP_AUTORENOVATION_URL,
                        '_blank'
                      )
                    }
                  />
                  <ActionButton
                    label={'Afiliarme a un plan'}
                    action={() => setShowAlffiliation(true)}
                  />
                </div>
              </>
            )}

            {curentStep === 1 && showAffiliation && (
              <>
                <LoadSpinner show={isLoading} />
                <form action="">
                  <h1
                    onClick={
                      ['true', true].includes(process.env.REACT_APP_DEVELOP)
                        ? () => preloadMembership()
                        : ''
                    }
                    className="sub-title-component"
                  >
                    1. Detalles del Vehículo
                  </h1>
                  {authService.getUser() && (
                    <>
                      <div className="row">
                        {watch('sameDate') ? (
                          <div className="col-2"></div>
                        ) : (
                          <div className="col-1"></div>
                        )}
                        <Input
                          bootstrap={'col-2'}
                          label={'Cantidad de Membresias '}
                          type={'select'}
                          name={'membershipQuantity'}
                          options={membershipQuantityOptions}
                          register={register}
                          placeholder={''}
                          errors={errors?.membershipQuantity?.message}
                          disabled={membershipList[0]?.dataTable}
                          onChange={() => handleMembershipList()}
                        />{' '}
                        <Input
                          bootstrap={'col-2'}
                          label={'Asesor '}
                          type={'select'}
                          name={'seller'}
                          options={sellerOptions}
                          register={register}
                          placeholder={''}
                          errors={errors?.seller?.message}
                        />{' '}
                        {authService.getUser() && (
                          <Input
                            bootstrap={'col-2'}
                            label={'Canal de Venta'}
                            type={'select'}
                            name={'salesChannel'}
                            options={salesChannelOptions}
                            register={register}
                            placeholder={''}
                            errors={errors?.salesChannel?.message}
                          />
                        )}
                        <div className="col-2">
                          <Input
                            // bootstrap={'col-2'}
                            label={'Fecha de creación'}
                            type={'date'}
                            name={'createdAt'}
                            register={register}
                            placeholder={''}
                            control={control}
                            errors={errors?.createdAt?.message}
                            minDate={determinValidDate()}
                            // Hasta el release (01/10/2026) se permite elegir fechas
                            // futuras; después se mantiene el máximo actual (hoy)
                            maxDate={isBeforePlanRelease() ? undefined : new Date()}
                            onChange={() => getCurrencyRateByDate()}
                          />
                          {authService.getUser() && (
                            <Input
                              label={'Misma Fecha de Pago'}
                              type={'checkbox'}
                              name={'sameDate'}
                              register={register}
                              placeholder={''}
                              control={control}
                              errors={errors?.sameDate?.message}
                              onChange={() => handleSameDateChange()}
                            />
                          )}
                        </div>
                        {authService.getUser() && !watch('sameDate') && (
                          <Input
                            bootstrap={'col-2'}
                            label={'Fecha de Pago'}
                            type={'date'}
                            name={'paymentDate'}
                            register={register}
                            placeholder={''}
                            control={control}
                            errors={errors?.createdAt?.message}
                            maxDate={new Date()}
                            onChange={() => getCurrencyRateByDate()}
                          />
                        )}
                      </div>
                      <MultipleMembershipsTable
                        table={multipleMembershipsTable}
                      />
                    </>
                  )}
                  {(clientNumber >= 0 || !authService.getUser()) && (
                    <LandingRegisterStep1Form
                      register={register}
                      errors={errors}
                      watch={watch}
                      validateTruck={validateTruck}
                      options={{
                        armorTypeOptions: armorTypeOptions,
                        vehicleClassesOptions: vehicleClassesOptions,
                        vehicleWeightOptions: vehicleWeightOptions,
                      }}
                      onChange={{
                        changeVehicleData: changeVehicleData,
                      }}
                    />
                  )}
                  {yearWatch && classWatch && clientNumber >= 0 && (
                    <>
                      <h1 className="sub-title-component">
                        2. Canjea aquí tu código de descuento o Giftcard
                      </h1>
                      <p style={{ textAlign: 'center' }}>
                        Si no posees ningún código, continua con la elección de
                        tu Plan.
                      </p>
                      <DiscountForm
                        register={register2}
                        watch={watch2}
                        errors={errors2}
                        options={{
                          codeTypeOptions: codeTypeOptions,
                        }}
                        onChange={{
                          getAvailableMemberships: getAvailableMemberships,
                          handleDiscountChange: handleDiscountChange,
                          handleGiftCardChange: handleGiftCardChange,
                          transformToUppercase: transformToUppercase,
                        }}
                        onSubmit={onSubmit2}
                      />
                      <div className="membership-buttons-container">
                        {giftCard && <GiftcardMessage giftCard={giftCard} />}
                        {discountCode && (
                          <DiscountMessage discountCode={discountCode} />
                        )}
                      </div>
                    </>
                  )}
                  {membershipOptions?.length > 0 &&
                    (clientNumber >= 0 || !authService.getUser()) && (
                      <>
                        <MembershipButtons
                          watch={watch}
                          membershipOptions={membershipOptions}
                          selectMembership={selectMembership}
                          selectedMembership={selectedMembership}
                          validateTruck={validateTruck}
                          noPlanAlert={noPlanAlert}
                        />
                      </>
                    )}
                  <div className="row">
                    <div className="col-12 col-md-4"></div>
                    {authService.getUser() && clientNumber >= 0 &&
                      authService.getUserType() !== salesRoles?.SALES_COUNTER && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            marginTop: '2%',
                            marginBottom: '2%',
                          }}
                        >
                          <div
                            style={{
                              margin: '0 auto',
                            }}
                            className=""
                          >
                            <Input
                              bootstrap={
                                'col-12 text-center justify-content-center align-items-center'
                              }
                              subLabel={'Agregar Certificado Médico'}
                              type={'checkbox'}
                              name={'useMedCert'}
                              placeholder={''}
                              register={register}
                              errors={errors?.km?.message}
                              onChange={handleRCVChange}
                            />
                          </div>
                        </div>
                      )}
                  </div>
                  {!newRules && (
                    <div className="row">
                      <div className="col-12 col-md-4"></div>
                      {[membershipCodes?.GOLD, membershipCodes?.GOLDM]?.includes(
                        selectedMembership?.code
                      ) && (
                          <>
                            <div className="col-12 col-md-4">
                              <div className="row">
                                <Input
                                  bootstrap={'col-12'}
                                  label={'Km de Servicio de Grúa'}
                                  type={'select'}
                                  name={'km'}
                                  options={KMServiceOptions}
                                  noBlankOption={true}
                                  placeholder={''}
                                  register={register}
                                  errors={errors?.km?.message}
                                  onChange={handleRCVChange}
                                />
                              </div>
                            </div>
                            <div className="col-12 col-md-4"></div>
                          </>
                        )}
                    </div>
                  )}
                  {rcvOptions?.length > 0 &&
                    (clientNumber >= 0 || !authService.getUser()) &&
                    !['RCV', 'RCV_ELITE', 'FREE']?.includes(
                      selectedMembership?.code
                    ) && (
                      <div className="row">
                        <div className="col-12 col-md-4"></div>
                        <div className="col-12 col-md-4">
                          <div className="row">
                            <Input
                              bootstrap={'col-12'}
                              label={'Elige Tipo de RCV'}
                              type={'select'}
                              name={'rcv'}
                              options={rcvOptions}
                              placeholder={''}
                              register={register}
                              errors={errors?.rcv?.message}
                              onChange={handleRCVChange}
                              noBlankOption={true}
                            />
                            {rcvCoverage()}
                          </div>
                        </div>
                        <div className="col-12 col-md-4"></div>
                      </div>
                    )}
                  {!['', rcvEnum.NA].includes(watch('rcv')) &&
                    selectedMembership?._id && (
                      <div className="row">
                        <div className="col-12 col-md-4"></div>
                        <div className="col-12 col-md-4">
                          <div className="row">
                            <Input
                              bootstrap={'col-12'}
                              label={'Uso del Vehículo * '}
                              type={'select'}
                              name={'vehicleUsage'}
                              options={vehicleFilerUsageOptions}
                              placeholder={''}
                              register={register}
                              errors={errors?.vehicleUsage?.message}
                              onChange={handleVehicleUsage}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4"></div>
                      </div>
                    )}
                  {planAllowsUnlimitedTow(selectedMembership?.code, createdAtWatch) && (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            margin: '0 auto',
                          }}
                          className=""
                        >
                          <Input
                            bootstrap={
                              'col-12 text-center justify-content-center align-items-center'
                            }
                            subLabel={getUnlimitedTowLabel(createdAtWatch)}
                            type={'checkbox'}
                            name={'useExtendedTow'}
                            placeholder={''}
                            register={register}
                            errors={errors?.km?.message}
                            onChange={handleRCVChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4"></div>
                    </>
                  )}
                  {authService.getUser() &&
                    clientNumber >= 0 &&
                    !['', rcvEnum.NA].includes(watch('rcv')) &&
                    selectedMembership?._id &&
                    authService.getUserType() !== salesRoles?.SALES_COUNTER && (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              margin: '0 auto',
                            }}
                            className=""
                          >
                            <Input
                              bootstrap={
                                'col-12 text-center justify-content-center align-items-center'
                              }
                              subLabel={'Agregar tarjeta RCV'}
                              type={'checkbox'}
                              name={'hasRcvCard'}
                              placeholder={''}
                              register={register}
                              errors={errors?.km?.message}
                              onChange={handleRCVChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4"></div>
                      </>
                    )}

                  <div
                    style={{ marginTop: '24px', marginBottom: '70px' }}
                    className="buttons-center-container "
                  >
                    <AltButton label={'Cancelar'} action={cancel} />
                    {clientNumber >= 0 && (
                      <ActionButton label={'Siguiente'} action={onSubmit} />
                    )}
                    {clientNumber < 0 && authService.getUser() && (
                      <ActionButton
                        label={'Confirmar'}
                        action={createMassive}
                      />
                    )}
                  </div>
                </form>
              </>
            )}
            {curentStep === 2 && authService.getUser() && (
              <MultipleAffiliationForm
                setcurentStep={setcurentStep}
                setCustomer={setCustomer}
                membership={membership}
                membershipList={membershipList}
                setMembershipList={setMembershipList}
                curentStep={curentStep}
              />
            )}
            {curentStep === 2 && !authService.getUser() && (
              <PersonalInfoForm
                setcurentStep={setcurentStep}
                setCustomer={setCustomer}
                membership={membership}
                membershipList={membershipList}
                curentStep={curentStep}
              />
            )}

            {curentStep === 3 && authService.getUser() && (
              <MultipleVehicleForm
                curentStep={curentStep}
                setcurentStep={setcurentStep}
                membership={membership}
                vehicle={vehicleMemo}
                customer={customer}
                selectedMembership={selectedMembership}
                membershipList={membershipList}
                setMembershipList={setMembershipList}
              />
            )}
            {curentStep === 3 && !authService.getUser() && (
              <CreateVehicleForm
                curentStep={curentStep}
                setcurentStep={setcurentStep}
                membership={createVehicleMembership}
                vehicle={vehicleMemo}
                customer={customer}
                selectedMembership={selectedMembership}
              />
            )}
            {curentStep === 4 && (
              <PlanPurchaseForm
                curentStep={curentStep}
                dollarRateByDate={dollarRateByDate}
                setcurentStep={setcurentStep}
                showAffiliation={showAffiliation}
                membership={purchaseMembership}
                selectedMembership={selectedMembership}
                vehicle={vehicleMemo}
                customer={customer}
                membershipList={membershipList}
                paymentDate={watch('paymentDate') || watch('createdAt')}
                dollarRate={dollarRate}
                isPublicLanding={authService?.getUserType()}
              />
            )}
            {curentStep === 5 && (
              <SuccesPurchase
                curentStep={curentStep}
                setcurentStep={setcurentStep}
                membership={purchaseMembership}
                selectedMembership={selectedMembership}
                vehicle={vehicleMemo}
                customer={customer}
                membershipList={membershipList}
                dollarRate={dollarRate}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export const MembershipButtons = (props) => {
  const {
    membershipOptions,
    selectMembership,
    selectedMembership,
    validateTruck,
    watch,
    noPlanAlert,
  } = props;

  if (validateTruck() && !watch('truckWeight')) {
    return (
      <h4
        style={{ textAlign: 'center', marginTop: '36px', marginBottom: '36px' }}
      >
        {' '}
        Indique el peso del camion
      </h4>
    );
  } else
    return (
      <>
        {' '}
        <h1 className="sub-title-component">3. Selecciona tu Plan</h1>
        <div className="membership-buttons-container">
          {membershipOptions?.map((m) => (
            <MembershipButton
              key={m?._id || m?.code}
              membership={m}
              selectMembership={selectMembership}
              selectedMembership={selectedMembership}
              noPlanAlert={noPlanAlert}
              rcv={watch('rcv')}
            />
          ))}
        </div>
      </>
    );
};
